import { useContext } from 'react';

import { TranslationContextProvider, TTranslations } from './TranslationsContext';

export const useTranslation = (translations: string | string[] = []): TTranslations => {
    const translationsContext = useContext(TranslationContextProvider);
    const translationsArray = [translations].flat();

    const translationObject: TTranslations = translationsArray.reduce((acc, translation) => {
        const translationNotFound =
            !translationsContext[translation] ||
            (!!translationsContext[translation] && translationsContext[translation] === '');

        return {
            ...acc,
            [translation]: translationNotFound
                ? `::${translation}::`
                : translationsContext[translation]
        };
    }, {});

    return Object.keys(translationObject).length ? translationObject : translationsContext;
};
